import {
  useGetAdminContent,
  type GetAdminContentParams,
  type GetAdminContentQueryResult,
} from '@/types/origin-point-engine'
import { mapAdminEngineItem } from '../lib/review.mappers'
import type {
  AdminEngineItemDTO,
  AdminEngineListVM,
  ReviewPaginationDTO,
} from '../types/review.types'

export const REVIEW_CACHE_LIMIT = 1000

function normalizeAdminContent(
  data: GetAdminContentQueryResult,
  page: number,
  limit: number
): AdminEngineListVM {
  // 后端返回结构存在「已包裹/未包裹」两种形态，这里逐层窄化为对象后再取值
  const root = data as Record<string, unknown> | undefined
  const rootData = root?.data as Record<string, unknown> | undefined
  const body =
    rootData?.success !== undefined ? rootData : (root as Record<string, unknown> | undefined)
  const payload = (body?.data as Record<string, unknown> | undefined) ?? body

  const rawItems = payload?.items
  const items = Array.isArray(rawItems)
    ? (rawItems as AdminEngineItemDTO[]).map(mapAdminEngineItem)
    : []

  const pagination =
    (payload?.pagination as ReviewPaginationDTO | undefined) ?? {
      page,
      pages: 1,
      limit,
      total: items.length,
    }

  return { items, pagination }
}

export function useAdminEnginesQuery(limit: number = REVIEW_CACHE_LIMIT) {
  const params: GetAdminContentParams = {
    page: 1,
    limit,
    type: 'engine',
  }

  return useGetAdminContent(params, {
    query: {
      staleTime: 10_000,
      queryKey: ['admin-engines-review-all', limit],
      select: (data) => normalizeAdminContent(data, 1, limit),
    },
  })
}
